import { FC } from 'react';

import FormButton from '../FormButton';

import { useGetStartedContext } from '../GetStarted/GetStarted.context';

import styles from './StepController.module.css';

export type Props = {
  disableNext?: boolean;
};

export const StepController: FC<Props> = ({ disableNext }) => {
  const { goNext, goPrev, state } = useGetStartedContext();

  return (
    <div className={styles.getStartedContentStepController}>
      {state?.showPrev && (
        <FormButton
          color="secondary"
          shadow="default"
          size="small"
          onClick={goPrev}
          align="start"
        >
          Prev
        </FormButton>
      )}
      {state?.showNext && (
        <FormButton
          color="primary"
          shadow="default"
          size="small"
          onClick={goNext}
          disabled={disableNext}
          align="end"
        >
          Next
        </FormButton>
      )}
    </div>
  );
};
